import script from "./CardPartidaLectura.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPartidaLectura.vue?vue&type=script&setup=true&lang=ts"

import "./CardPartidaLectura.vue?vue&type=style&index=0&id=5d39bbd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d39bbd0"]])

export default __exports__